import React, { Fragment, useEffect, useState } from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  elementContainer,
  checklistItemStyles
} from '../../../styles/classes/MobilePreviewClasses'
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons'
import { useTranslation } from 'react-i18next'
import { IOSSwitch } from '../../../styles/mui_custom_components'
import HelpfulHintPopUp from '../HelpfulHintPopUp'
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { checkBoxModes } from '../../../utils/mobilePreview'

const CheckListItem = ({
  title,
  helpfulHint,
  mode,
  onChangeValue,
  answer,
  isMandatory,
  disabled
}) => {
  const [open, setOpen] = useState(false)
  const [localValue, setLocalValue] = useState(
    answer !== undefined ? answer : null
  )
  const { t } = useTranslation()
  const elementContainerClasses = elementContainer().classes
  const { classes } = checklistItemStyles()

  useEffect(() => {
    onChangeValue(localValue)
  }, [localValue])

  const changeValueHandler = () => {
    if (mode === checkBoxModes.TOGGLE) {
      setLocalValue(prevVal => !prevVal)
    } else {
      switch (localValue) {
        case true:
          setLocalValue(false)
          break
        case false:
          setLocalValue(null)
          break
        case null:
          setLocalValue(true)
          break
        default:
          setLocalValue(true)
          break
      }
    }
  }

  const openCloseModalHandler = () => {
    setOpen(prev => !prev)
  }

  const CheckList = ({ value, disabled }) => {
    let checkIconStyles
    let containerStyle = classes.checkContainer
    if (value === true) {
      checkIconStyles = classes.icon
    }
    if (value === false) {
      checkIconStyles = classes.iconRed
    }
    if (disabled) {
      checkIconStyles = classes.iconDisabled
      containerStyle = classes.checkContainerDisabled
    }
    return (
      <div className={containerStyle}>
        <IconButton
          disableRipple
          aria-label="delete"
          size="small"
          className={classes.inconButton}
          onClick={changeValueHandler}
          disabled={disabled}
        >
          {value === true && (
            <FontAwesomeIcon className={checkIconStyles} icon={faCheck} />
          )}
          {value === false && (
            <FontAwesomeIcon className={checkIconStyles} icon={faTimes} />
          )}
          {value === null && null}
        </IconButton>
      </div>
    )
  }

  return (
    <Fragment>
      <Box className={[classes.container]}>
        <Box display={'flex'}>
          <Typography className={elementContainerClasses.title}>
            {isMandatory && <span className={classes.required}>*</span>}
            {title}
          </Typography>
          {helpfulHint?.length > 0 && (
            <FontAwesomeIcon
              className={elementContainerClasses.icon}
              icon={faQuestionCircle}
              onClick={openCloseModalHandler}
            />
          )}
        </Box>
        <div>
          {mode === checkBoxModes.CHECK_BOX && <CheckList value={localValue} disabled={disabled} />}
          {mode === checkBoxModes.TOGGLE && (
            <IOSSwitch checked={localValue} onChange={changeValueHandler} disabled={disabled} />
          )}
          {[checkBoxModes.ON_OFF, checkBoxModes.YES_NO].includes(mode) && (
            <div>
              <div className={classes.boxesContainer}>
                <div className={classes.boxHeader}>
                  <Typography className={classes.boxHeaderText}>
                    {mode === checkBoxModes.ON_OFF &&
                      t('mobile_preview.check_list.on')}
                    {mode === checkBoxModes.YES_NO &&
                      t('mobile_preview.check_list.yes')}
                  </Typography>
                </div>
                <div className={classes.boxHeader}>
                  <Typography className={classes.boxHeaderText}>
                    {mode === checkBoxModes.ON_OFF &&
                      t('mobile_preview.check_list.off')}
                    {mode === checkBoxModes.YES_NO &&
                      t('mobile_preview.check_list.no')}
                  </Typography>
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                {localValue === true
                  ? (
                  <CheckList value={true} disabled={disabled} />
                    )
                  : (
                  <CheckList value={null} disabled={disabled}/>
                    )}
                {localValue === false
                  ? (
                  <CheckList value={false} disabled={disabled}/>
                    )
                  : (
                  <CheckList value={null} disabled={disabled}/>
                    )}
              </div>
            </div>
          )}
        </div>
      </Box>

      <HelpfulHintPopUp
        open={open}
        onClose={openCloseModalHandler}
        text={helpfulHint}
      />
    </Fragment>
  )
}

export default CheckListItem
